<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>

import BottomSheet from '../BottomSheet';
import DashboardView from './DashboardView.vue';

export default {
  name: "BillingDashboard",
  components: {
    BottomSheet
  },
  routes: [
    {
      path: '',
      redirect: '/billing/dashboard/view'
    },
    {
      path: "view",
      component: DashboardView,
      name: "Dashboard View"
    },
  ]
}
</script>